import Swiper from "swiper/bundle"
export default class CarouselBackground {
    constructor() {
        this.carousel = {
            element: document.querySelector(
                '.carousel[data-carousel="background"]'
            ),
        }

        this.createCarousel(this.carousel.element) // Init Carousel
    }

    createCarousel(target) {
        var carousel = new Swiper(target, {
            slidesPerView: 1,
            spaceBetween: 0,
            grabCursor: false,
            navigation: false,
            scrollbar: false,
            autoplay: true,
            speed: 3000,
            effect: "fade",
            rewind: true,
            navigation: {
                nextEl: "[data-next]",
                prevEl: "[data-prev]",
            },
        })
    }
}
